<div class="device-info-page">
    <div class="emma-card auto-width device-overview-card">
        <div class="device-overview-card__content">
            <div class="device-info-card__shell">
                <div class="device-info-hero device-inset-panel">
                    <div class="device-info-hero__content">
                        <div class="device-panel-header">
                            <div class="device-panel-header__eyebrow">{{ "DEVICE.Info" | translate }}</div>
                            <div class="device-panel-header__title">{{ device?.deviceName }}</div>
                        </div>

                        <div class="device-info-hero__meta">
                            <span class="device-info-hero__tag">
                                <mat-icon>memory</mat-icon>
                                {{ device.baseDeviceData?.name || "-" }}
                            </span>

                            @if (device.baseDeviceData?.serialNumber) {
                                <span class="device-info-hero__tag">
                                    <mat-icon>local_offer</mat-icon>
                                    {{ device.baseDeviceData?.serialNumber }}
                                </span>
                            }
                        </div>
                    </div>

                    <div class="device-info-hero__mark">
                        {{ device.baseDeviceData?.model || device.baseDeviceData?.name || device?.deviceName }}
                    </div>
                </div>

                <div class="device-info-grid">
                    <div class="device-info-tile">
                        <div class="device-info-tile__label">{{ "DEVICE.BaseName" | translate }}</div>
                        <div class="device-info-tile__value">{{ device.baseDeviceData?.name || "-" }}</div>
                    </div>

                    <div class="device-info-tile">
                        <div class="device-info-tile__label">{{ "DEVICE.SerialNumber" | translate }}</div>
                        <div class="device-info-tile__value">{{ device.baseDeviceData?.serialNumber || "-" }}</div>
                    </div>

                    <div class="device-info-tile">
                        <div class="device-info-tile__label">{{ "DEVICE.SimOrImei" | translate }}</div>
                        <div class="device-info-tile__value">{{ device.baseDeviceData?.simOrImei || "-" }}</div>
                    </div>

                    <div class="device-info-tile">
                        <div class="device-info-tile__label">{{ "DEVICE.LastCalibrationDate" | translate }}</div>
                        <div class="device-info-tile__value">
                            @if (device.baseDeviceData?.lastCalibrationDate) {
                                {{ device.baseDeviceData?.lastCalibrationDate | date: "mediumDate" }}
                            } @else {
                                -
                            }
                        </div>
                    </div>

                    <div class="device-info-tile">
                        <div class="device-info-tile__label">{{ "DEVICE.Latitude" | translate }}</div>
                        <div class="device-info-tile__value">{{ device.location?.latitude ?? "-" }}</div>
                    </div>

                    <div class="device-info-tile">
                        <div class="device-info-tile__label">{{ "DEVICE.Longitude" | translate }}</div>
                        <div class="device-info-tile__value">{{ device.location?.longitude ?? "-" }}</div>
                    </div>

                    <div class="device-info-tile device-info-tile--wide">
                        <div class="device-info-tile__label">{{ "DEVICE.Comments" | translate }}</div>
                        <div class="device-info-tile__value device-info-tile__value--multiline">
                            {{ device?.comments || "-" }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="device-location-card device-inset-panel">
                <div class="device-panel-header device-panel-header--compact">
                    <div class="device-panel-header__title">{{ "DEVICE.Location" | translate }}</div>
                </div>
                @if (validCoordinates) {
                    <div
                        class="device-location-map"
                        leaflet
                        [leafletOptions]="mapOptions"
                        [leafletLayers]="mapLayers"
                        (leafletMapReady)="onMapReady($event)"
                    ></div>
                }
                <div class="address">
                    {{ device.location?.address }}
                </div>
            </div>
        </div>
    </div>

    @if (showPicture) {
        <div class="emma-card auto-width device-picture-card" fxLayout="column" fxLayoutAlign="space-between center">
            <div class="p-16">
                <div class="h1 pr-16">{{ "DEVICE.Picture" | translate }}</div>
            </div>
            @if (pictureCloudinaryImage; as deviceImage) {
                <advanced-image [cldImg]="deviceImage"></advanced-image>
            } @else {
                <img [src]="picture" alt="device picture" />
            }
        </div>
    }

    @if (showLF010Section) {
        <section class="emma-card auto-width lf010-section">
            <div class="lf010-section__header">
                <div class="lf010-section__eyebrow">LF010</div>
                <div class="lf010-section__title">{{ "DEVICE.LF010SectionTitle" | translate }}</div>
                <div class="lf010-section__subtitle">
                    {{ "DEVICE.LF010SectionHelp" | translate }}
                </div>
            </div>

            <div class="lf010-section__content">
                @if (showLF010Periods) {
                    <div class="lf010-panel lf010-panel--limits lf010-periods">
                        <div class="lf010-panel__header">
                            <div class="lf010-panel__title">
                                {{ "DEVICE.LF010PeriodLimits" | translate }}
                            </div>
                            <div class="lf010-panel__subtitle">
                                {{ "DEVICE.LF010PeriodLimitsHelp" | translate }}
                            </div>
                        </div>

                        <div class="lf010-periods__grid lf010-periods__grid--head">
                            <div>{{ "DEVICE.LF010DevicePeriod" | translate }}</div>
                            <div>{{ "DEVICE.LF010Limit" | translate }}</div>
                            <div>{{ "DEVICE.ProjectPeriod" | translate }}</div>
                        </div>

                        @for (period of lf010Periods; track period.devicePeriod) {
                            <div class="lf010-periods__grid lf010-periods__grid--row">
                                <div class="lf010-periods__period">{{ period.name }}</div>
                                <div>
                                    <span class="lf010-periods__pill lf010-periods__pill--limit">
                                        @if (period.emissionLimit !== undefined && period.emissionLimit !== null) {
                                            {{ period.emissionLimit }} dBA
                                        } @else {
                                            -
                                        }
                                    </span>
                                </div>
                                <div>
                                    <span class="lf010-periods__pill lf010-periods__pill--mapping">
                                        {{ period.projectPeriodName || ("DEVICE.NotMapped" | translate) }}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                }

                @if (showLF010LimitHistory) {
                    <div class="lf010-panel lf010-panel--history lf010-history">
                        <div class="lf010-panel__header">
                            <div class="lf010-panel__title">
                                {{ "DEVICE.LF010LimitHistory" | translate }}
                            </div>
                            <div class="lf010-panel__subtitle">
                                {{ "DEVICE.LF010LimitHistoryHelp" | translate }}
                            </div>
                        </div>

                        @if (lf010LimitHistory.length) {
                            <div class="lf010-history__table-wrap">
                                <table mat-table [dataSource]="paginatedLF010LimitHistory" class="lf010-history__table">
                                    <ng-container matColumnDef="period">
                                        <th mat-header-cell *matHeaderCellDef>{{ "DEVICE.LF010DevicePeriod" | translate }}</th>
                                        <td mat-cell *matCellDef="let entry">{{ entry.name }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="previousLimit">
                                        <th mat-header-cell *matHeaderCellDef>{{ "DEVICE.LF010PreviousLimit" | translate }}</th>
                                        <td mat-cell *matCellDef="let entry">{{ entry.previousEmissionLimit }} dBA</td>
                                    </ng-container>

                                    <ng-container matColumnDef="newLimit">
                                        <th mat-header-cell *matHeaderCellDef>{{ "DEVICE.LF010NewLimit" | translate }}</th>
                                        <td mat-cell *matCellDef="let entry">{{ entry.emissionLimit }} dBA</td>
                                    </ng-container>

                                    <ng-container matColumnDef="changedAt">
                                        <th mat-header-cell *matHeaderCellDef>{{ "DEVICE.LF010ChangedAt" | translate }}</th>
                                        <td mat-cell *matCellDef="let entry">{{ entry.changedAt | date: "medium" }}</td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="lf010HistoryColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: lf010HistoryColumns"></tr>
                                </table>
                            </div>

                            <mat-paginator
                                class="lf010-history__paginator"
                                [length]="lf010LimitHistory.length"
                                [pageIndex]="lf010HistoryPageIndex"
                                [pageSize]="lf010HistoryPageSize"
                                [pageSizeOptions]="lf010HistoryPageSizeOptions"
                                [showFirstLastButtons]="true"
                                (page)="onLF010HistoryPageChange($event)"
                            ></mat-paginator>
                        } @else {
                            <div class="lf010-history__empty">
                                {{ "DEVICE.LF010LimitHistoryEmpty" | translate }}
                            </div>
                        }
                    </div>
                }
            </div>
        </section>
    }
</div>
